import {Component, OnInit} from '@angular/core';
import {BannerContentModel} from "../banner-content.model";
import {TranslationService} from "../../../../services/wrapper/translation.service";
import {BannerLayoutComponent} from "../../banner-layout.component";
import {BsModalService} from "ngx-bootstrap";
import {NotificationService} from "../../../../services/common/notification.service";
import {MyStorageService} from "../../../../services/common/my-storage.service";

@Component({
    selector: 'app-title-and-desc-content',
    templateUrl: './title-and-desc-content.component.html',
    styleUrls: ['./title-and-desc-content.component.scss']
})
export class TitleAndDescContentComponent extends BannerLayoutComponent<BannerContentModel> implements OnInit {
    title = '';
    description = '';

    constructor(myStorageService:MyStorageService, translationService: TranslationService, modalService: BsModalService, notificationService: NotificationService) {
        super( translationService, modalService, notificationService, myStorageService);
    }

    ngOnInit(): void {
        this.title = this.translate(this.data.title);
        this.description = this.translate(this.data.description);
    }

}
